import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import ColumnChart from "@/shared/components/charts/ColumnChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import InlineSpan from "@/shared/components/report-template/presentation/components/common/InlineSpan";
import Description from "@/shared/components/report-template/presentation/components/common/Description";

interface FinalLandSuitabilityIndexProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
}

const FinalLandSuitabilityIndex = ({
  croppingSuitabilityReports,
}: FinalLandSuitabilityIndexProps) => {
  const noteText = `شاخص نهایی تناسب زمین برای کاشت گندم ${croppingSuitabilityReports[0]?.landSuitabilityClass?.manyPercent} درصد است که در کلاس تناسبی ${croppingSuitabilityReports[0]?.landSuitabilityClass?.name} قرار می‌گیرد.`;

  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={2}>
      <div className="w-full flex flex-col gap-6">
        <Title>شاخص تناسب نهایی زمین برای محصولات مختلف</Title>

        <Description>
          برای محصول{" "}
          <span className="font-semibold text-[18px] leading-[28px] !font-[B-Nazanin] text-president">
            {croppingSuitabilityReports[0]?.crop?.persianName}
          </span>
          ، تناسب پارامترهای کلیدی شامل شاخص تامین نیاز آبی، دمای طول فصل رشد،
          بارندگی طول فصل رشد، درجه روز رشد، هدایت الکتریکی ، pH ، بافت، کربن
          آلی، شیب زمین، و عمق خاک بررسی شده است. نتایج تناسب هر پارامتر در
          نمودار زیر مشخص شده است.
        </Description>

        <div className="w-full flex flex-col justify-center items-center">
          <Title>شاخص تناسب زمین برای پارامترهای مختلف</Title>
        </div>

        <ColumnChart
          data={[
            {
              value:
                croppingSuitabilityReports[0]?.averageGrowingSeasonTemperature,
              name: "میانگین دمای فصل رشد",
            },
            {
              value:
                croppingSuitabilityReports[0]
                  ?.totalRainfallDuringTheGrowingPeriod,
              name: "مجموع بارندگی در طول دوره رشد",
            },
            {
              value: croppingSuitabilityReports[0]?.degreeDayGrowingSeason,
              name: "درجه روز رشد فصل",
            },
            {
              value: croppingSuitabilityReports[0]?.slopeLand,
              name: "شیب زمین",
            },
            {
              value: croppingSuitabilityReports[0]?.soilElectricalConductivity,
              name: "هدایت الکتریکی خاک",
            },
            {
              value: croppingSuitabilityReports[0]?.soilAcidity,
              name: "اسیدیته خاک",
            },
            {
              value: croppingSuitabilityReports[0]?.soilTexture,
              name: "بافت خاک",
            },
            {
              value: croppingSuitabilityReports[0]?.soilDepth,
              name: "عمق خاک",
            },
            {
              value: croppingSuitabilityReports[0]?.soilOrganicCarbon,
              name: "کربن آلی خاک",
            },
            {
              value: croppingSuitabilityReports[0]?.waterSupplyIndex,
              name: "شاخص تامین نیاز آبی",
            },
          ]}
          height={320}
          titleFontSize="12px"
          labelsFontSize="10px"
          decimalNumber={0}
        />

        <div className=" w-full flex flex-col justify-center items-center">
          <Title>مقایسه تناسب زمین از لحاظ پارامترهای مختلف</Title>
        </div>

        <div className="text-center">
          <NoteBox>{noteText}</NoteBox>
        </div>

        <Description>
          <>
            {`
          باتوجه به ویژگی‌های خاکشناسی زمین، داده‌های اقلیمی و منابع آبی، این
          زمین برای کاشت محصول
          ${croppingSuitabilityReports[0]?.crop?.persianName}`}
            <InlineSpan>
              {croppingSuitabilityReports[0]?.landSuitabilityClass?.label}
            </InlineSpan>
            {`
          است. زمین دارای برخی محدودیت‌های متوسط است که ممکن است عملکرد محصول را
          نسبت به شرایط ایده‌آل کاهش دهد، اما همچنان برای کاشت این محصول قابل
          ‌قبول است.`}
          </>
        </Description>
      </div>
    </ReportTemplate>
  );
};

export default FinalLandSuitabilityIndex;
